/* A small trend on a task card — see `TrendCard.tsx`. */

.trend {
  display: flex;
  flex-direction: column;
  gap: var(--space-6px);
  min-width: 0;
}

.head {
  display: flex;
  gap: var(--space-3);
  align-items: baseline;
  justify-content: space-between;
  min-width: 0;
}

.title {
  overflow: hidden;
  font-size: var(--fs-label);
  font-weight: var(--fw-bold);
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--text-2);
}

.latest {
  flex: none;
  font-size: var(--fs-label-md);
  font-weight: var(--fw-extrabold);
  font-variant-numeric: tabular-nums;
  color: var(--text);
}
